export default __webpack_public_path__ + "static/media/exe.a02a8952.svg";